// extracted by mini-css-extract-plugin
export default {"layout":"Tf7KZwa_","content":"Nr0Nwwcd","footer":"ErSNJ00T","breadcrumbLink":"aQxkOyLj","logo":"TPREepLh"};